import React from 'react';
import styled from 'styled-components';
import { defer } from '/imports/utils';
import { InputProps, InputStyled } from '/imports/ui/Input';
import { Icon } from '/imports/ui/Icon';

const DateInputStyled = styled(InputStyled)`
  /* Firefox */
  input[type=number] {
    appearance: inherit;
    -moz-appearance: textfield;
  }
`;

export interface DateInputProps extends InputProps<string> {
  className?: string;
  disabled?: boolean;
  step?: string;
  min?: string;
  max?: string;
  onFocus?(e: React.FocusEvent<HTMLInputElement, Element>): void;
  onBlur?(e: React.FocusEvent<HTMLInputElement, Element>): void;
  seconds?: boolean;
  zone?: string;
}

/** Date input with a clear button and icon support. */
export const DateInput = (props: DateInputProps) => {
  const hasStartIcon = props.icon && props.iconPlacement !== 'end';
  /** Clears the value and fires onClear. */
  const clearInput = () => {
    props.onChange?.(undefined);
    defer(() => props.onClear?.());
  };
  /** @param e - change event */
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => props.onChange?.(e.target.value, e);
  /** @param e - blur event */
  const onBlur = (e: React.FocusEvent<HTMLInputElement, Element>) => props.onBlur?.(e);
  return (
    <DateInputStyled id={props.id} className={`input number-input ${props.className || ''}${props.hasError ? ' error' : ''}`}>
      {hasStartIcon && <Icon className="icon-start" icon={props.icon as any} />}
      <input
        id={props.inputId}
        className={hasStartIcon ? 'has-start-icon' : ''}
        type="date"
        step={props.step || ''}
        min={props.min}
        max={props.max}
        placeholder={props.placeholder || ''}
        disabled={props.disabled}
        autoFocus={props.autoFocus}
        value={props.value}
        onChange={(e) => onChange(e)}
        onClick={(e) => props.onClick?.(e)}
        onFocus={props.onFocus}
        onBlur={(e) => onBlur(e)}
        onKeyUp={(e) => {
          props.onKeyPress?.(e);
          if (e.key === 'Enter') defer(() => props.onEnter?.(props.value, e));
        }}
        autoComplete={props.autoComplete}
      />
      {
        props.value !== undefined &&
        !props.disabled &&
        !(props.type === 'color') &&
        <Icon className="clear" icon="cancel" onClick={() => clearInput()} /> || null
      }
    </DateInputStyled>
  );
};